import academyLinks from './academyLinks';

export default academyLinks;
